<template>
    <div class="main_holder">
        <div class="content_holder">
            <div class="content">
                <h2>Obvestila</h2>

                <div v-if="getUserType == 2">
                    <div class="faq_texteditor_content">
                        <button class="as_link icon button" title="Dodaj obvestilo"
                            @click="showModal({ component: 'users/CreateNotice' })">
                            <font-awesome-icon :icon="['far', 'plus-square']" /> Dodaj obvestilo
                        </button>
                    </div>
                </div>

                <div class="notices_text_content" v-for="notice in filteredNotices" :key="notice.id">
                    <div class="notice_title">
                        <div class="notice_date"><i>{{ convertDate(notice.created) }}</i></div>
                        <div class="notice_stamp" v-if="notice.tabs.includes('0') && getUser.access_sections == 1">
                            Poslovno poročanje</div>
                        <div class="notice_stamp" v-if="notice.tabs.includes('1') && getUser.access_work_plan == 1">Letni
                            program dela</div>
                        <div class="notice_stamp" v-if="notice.tabs.includes('2') && getUser.access_evalvation == 1">
                            Samoevalvacija ŠP</div>
                    </div>
                    <span v-html="notice.text"></span>
                    <font-awesome-icon v-if="isNewNotice(notice.created)" :icon="['fas', 'exclamation-circle']"
                        class="color_red icon_new_notices" />

                    <div class="notice_tools" v-if="getUserType == 2">
                        <span @click="showModal({ component: 'users/EditNotice', data: { id: notice.id } })">
                            <font-awesome-icon :icon="['fas', 'pencil']" class="as_link icon" />
                        </span>
                        <span @click="showModal({ component: 'users/DeleteNotice', data: { id: notice.id } })">
                            <font-awesome-icon :icon="['fas', 'trash-alt']" class="as_link icon" />
                        </span>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>


<script>
import { mapActions } from "vuex";
import moment from 'moment';

export default {
    name: "Notices",
    data: function () {
        return {
        };
    },
    computed: {
        // Get loged user type
        getUserType() {
            return this.$store.state.user.type;
        },

        // Get loged user data
        getUser() {
            return this.$store.state.user;
        },

        notices() {
            if (this.$store.getters.notices)
                return Object.values(this.$store.getters.notices).reverse();
            else
                return [];
        },

        filteredNotices: function () {
            // for normal user filter the notices based on access, for others show all
            if (this.getUserType != 0)
                return this.notices;
            else
                return this.notices.filter((data) => {
                    if (
                        (data.tabs.includes('0') && this.getUser.access_sections == 1) ||
                        (data.tabs.includes('1') && this.getUser.access_work_plan == 1) ||
                        (data.tabs.includes('2') && this.getUser.access_evalvation == 1)
                    ) {
                        return true;
                    }
                    return false;
                });
        },
    },
    methods: {
        ...mapActions([
            "getNotices",
            "noticesRead",
            'showModal',
        ]),

        convertDate(date) {
            return moment(date, 'YYYY-MM-DD HH:mm:ss').format('D. M. YYYY');
        },

        //check if there are new notices for user
        isNewNotice(notice_created) {
            const notice_time = new Date(notice_created);
            const user_notice_checked = new Date(this.getUser.notices_checked);

            return notice_time > user_notice_checked;
        }

    },
    created() {
        this.getNotices();
    },
    beforeUnmount() {
        // Update read time when navigating away
        this.noticesRead();
    },
};
</script>


<style lang="scss" scoped></style>
